import { useCachedLyricsParts } from "../../../chordsheet/useCachedLyricsParts";

interface Props {
  songId: string;
}

export function LyricsPreview({ songId }: Props) {
  const cachedParts = useCachedLyricsParts(songId);

  if (cachedParts.length === 0) {
    return <></>;
  }

  const previewText = cachedParts.map((part) => part.content).join(" ");

  return (
    <div
      className="text-secondary small"
      style={{
        textOverflow: "ellipsis",
        overflow: "hidden",
        whiteSpace: "nowrap",
      }}
    >
      {previewText.slice(0, 350)}
    </div>
  );
}
